<template>
    <div id="rattachment-view">
        <LoadingDots v-if="isLoading" />
        <RattachmentObjectInfo
            v-if="activeObject && !isLoading && settings.mod_rattachment_enable === '1'"
            :open="openInfo"
            :object="activeObject"
            :inverse="inverse"
            @object-info:dismiss="closeObjectInfo"
            @object-info:waiting="showComment = true"
            @object-info:accept="handleAction('valid')"
            @object-info:reject="handleAction('invalid')"
            @object-info:validInverseForm="validInverseForm"
            @unselect:object="unselectObject"
        />
        <div class="rattachment-menu" v-if="!isLoading && settings.mod_rattachment_enable === '1'">
            <div class="logo"><img src="@/assets/logo.png" /></div>
            <div class="config">
                <template v-if="inverse === true">
                    <ConfigLink icon="arrows-alt-h" link="/rattachmentinverse"
                        >Rattachement inverse</ConfigLink
                    >
                </template>
                <template v-if="inverse !== true">
                    <ConfigLink icon="arrows-alt-h" link="/rattachment"
                        >Rattachement classique</ConfigLink
                    >
                </template>
            </div>
            <!-- Objets des sessions de rattachement -->
            <div class="objects">
                <RattachmentObjects
                    :key="'objects'"
                    :loading="isLoading2"
                    :rattachments="rattachments"
                    :activeObject="activeObject"
                    :inverse="inverse"
                    @display:object="displayObject"
                />
            </div>
            <!-- Couches -->
            <div class="layers" v-if="activeGeomObject">
                <div class="layers-title">Couches</div>
                <div class="layer geom" v-if="inverse !== true">
                    <Checkbox v-model="showRattachementsLayer" />
                    <span>Nouveau filaire inutilisé</span>
                </div>
                <div class="layer oldratgeom" v-if="inverse !== true">
                    <Checkbox v-model="showOldRattachedLayer" />
                    <span>Filaires déjà rattachés</span>
                </div>
                <div class="layer oldnonratgeom" v-if="inverse !== true">
                    <Checkbox v-model="showOldNonRattachedLayer" />
                    <span>Filaires à rattacher</span>
                </div>
                <div class="layer inversemetierratgeoms" v-if="inverse === true">
                    <Checkbox v-model="showFilaireMetierLayer" />
                    <span>Filaires métier</span>
                </div>
                <div class="layer inversemetiernonratgeoms" v-if="inverse === true">
                    <Checkbox v-model="showNonRattachedInverseLayer" />
                    <span>Filaires métier à rattacher</span>
                </div>
            </div>
            <!-- Boutons nav -->
            <MenuLink></MenuLink>
        </div>
        <OsmMap
            v-if="!isLoading && settings.mod_rattachment_enable === '1'"
            :activeObject="activeGeomObject"
            :overlayOffset="overlayOffset"
            :objectLayers="objectLayers"
            :popup="popup"
            @event:click="handleMapClick"
            @updateBounds="handleBoundsChange"
        />
    </div>
</template>

<script>
import LoadingDots from '@/components/LoadingDots';
import ConfigLink from '@/components/ConfigLink';
import OsmMap from '@/components/OsmMap';
import RattachmentObjects from './RattachmentObjects';
import RattachmentObjectInfo from './RattachmentObjectInfo';
import { authenticationService } from '@/services';
import Checkbox from '@/components/Checkbox';
import MenuLink from '@/layouts/Menu.vue';

export default {
    props: {
        inverse: { type: Boolean, default: false },
    },
    data() {
        return {
            isLoading: true,
            openInfo: false,
            activeObject: null,
            activeGeomObject: null,
            popup: null,
            bounds: null,
            objectLayers: [],
            rattachments: [],
            isLoading2: false,
            overlayOffset: 0,
            user: authenticationService.currentUserValue,
            showRattachementsLayer: true,
            showOldRattachedLayer: false,
            showOldNonRattachedLayer: true,
            showFilaireMetierLayer: true,
            showNonRattachedInverseLayer: true,
            settings: {
                mod_rattachment_enable: null,
            },
            loaded_settings: [],
        };
    },

    created() {},

    mounted() {
        this.loadSettings();
        // Récupère le contenu du menu
        this.getRattachmentsMenu();
    },

    watch: {
        showRattachementsLayer: function() {
            this.refreshLayers();
        },
        showOldRattachedLayer: function() {
            this.refreshLayers();
        },
        showOldNonRattachedLayer: function() {
            this.refreshLayers();
        },
        showFilaireMetierLayer: function() {
            this.refreshLayers();
        },
        showNonRattachedInverseLayer: function() {
            this.refreshLayers();
        },
    },

    methods: {
        loadSettings() {
            this.$http
                .get('/api/setting/')
                .then(
                    (response) => {
                        const settings = response.body;
                        this.loaded_settings = settings;
                        settings.forEach((s) => (this.settings[s.name] = s.value));
                    },
                    (response) => {
                        // error callback
                        console.log(JSON.stringify(response));
                    },
                )
                .finally(() => {
                    this.activatedVerif();
                    this.isLoading = false;
                });
        },

        activatedVerif() {
            if (this.settings.mod_rattachment_enable !== '1') {
                this.$router.push({ path: '/home' });
            }
        },

        /**
         * Événement appelé au changement d'étendue sur la carte
         */
        handleBoundsChange(payload) {
            this.bounds = payload;
            // Si la carte est déplacée, l'arbre est rechargé
            this.getRattachmentsMenu();
        },

        /**
         * Charge l'arbre des rattachements
         */
        getRattachmentsMenu(openedRattachments) {
            this.isLoading2 = true;
            this.rattachments = [];

            // Au premier chargement bounds est nul
            // Ensuite, via le zoom automatique, on a l'étendue globale
            var Xmin = '';
            var Xmax = '';
            var Ymin = '';
            var Ymax = '';

            if (this.bounds) {
                Xmin = this.bounds.getWest();
                Xmax = this.bounds.getEast();
                Ymin = this.bounds.getSouth();
                Ymax = this.bounds.getNorth();
            }

            this.$http
                .get(
                    `/api/rattachment/${
                        this.inverse === true ? 'menuinverse' : 'menu'
                    }?Xmin=${Xmin}&Xmax=${Xmax}&Ymin=${Ymin}&Ymax=${Ymax}`,
                )
                .then(
                    (response) => {
                        // success callback
                        if (response && response.status === 200 && response.body) {
                            this.rattachments = response.body;
                        } else {
                            console.error('response not valid', response);
                        }
                        this.isLoading2 = false;
                        // Met à jour les rattachements précédemment ouverts
                        if (openedRattachments) {
                            this.setOpenedRattachments(openedRattachments, this.rattachments);
                        }
                    },
                    (response) => {
                        // error callback
                        console.error(JSON.stringify(response));
                        this.isLoading2 = false;
                    },
                );
        },
        /**
         * Charge la géométrie du rattachement
         */
        loadRattachmentObjectGeom(rattachment, object) {
            return new Promise((resolve, reject) => {
                this.isLoading2 = true;
                const object_id =
                    object[`${rattachment.fid}${this.inverse === true ? '' : '_old_rattachment'}`];

                if (object.new_geom) {
                    const geom = object.new_geom;
                    delete object.new_geom;

                    // Permet de zoomer sur la nouvelle feature
                    // this.activeGeomObject = {
                    //     color: '#FFFF00',
                    //     new_geom: geom,
                    // };
                    this.isLoading2 = false;
                    geom.id = object_id;
                    resolve(geom);
                } else {
                    this.activeGeomObject = null;
                    this.$http.get(`/api/rattachment/${rattachment.id}/${object_id}/geom`).then(
                        (response) => {
                            // success callback
                            if (response && response.status === 200 && response.body) {
                                const geom = response.body;
                                geom.id = object_id;
                                this.activeGeomObject = {
                                    color: '#FFFF00',
                                    new_geom: geom,
                                };
                                resolve(geom);
                            } else {
                                console.error('response not valid', response);
                            }
                            this.isLoading2 = false;
                            resolve();
                        },
                        (response) => {
                            // error callback
                            console.error(JSON.stringify(response));
                            this.isLoading2 = false;
                            reject();
                        },
                    );
                }
            });
        },
        /**
         * Retourne une couche contenant les géométries demandées selon le type :
         * geom : Le nouveau filaire en gris
         * oldratgeom : Les anciens filaires déjà rattachés en vert
         * oldnonratgeom : Les anciens filaires encore à rattacher en rouge
         */
        getRattachementLayer(type, rattachment) {
            return new Promise((resolve, reject) => {
                const layer = {
                    ids: [],
                    new_geom: [],
                };

                if (type === 'geoms') {
                    layer.type = 'filaires';
                    layer.color = '#6c757d';
                    if (!this.showRattachementsLayer) {
                        resolve(layer);
                        return;
                    }
                } else if (type === 'oldratgeoms') {
                    layer.type = 'oldratgeoms';
                    layer.color = '#28a745';
                    if (!this.showOldRattachedLayer) {
                        resolve(layer);
                        return;
                    }
                } else if (type === 'oldnonratgeoms') {
                    layer.type = 'oldnonratgeoms';
                    layer.color = '#dc3545';
                    if (!this.showOldNonRattachedLayer) {
                        resolve(layer);
                        return;
                    }
                } else if (type === 'inversemetierratgeoms') {
                    layer.type = 'inversemetierratgeoms';
                    layer.color = '#28a745';
                    if (!this.showFilaireMetierLayer) {
                        resolve(layer);
                        return;
                    }
                } else if (type === 'inversemetiernonratgeoms') {
                    layer.type = 'inversemetiernonratgeoms';
                    layer.color = '#dc3545';
                    if (!this.showNonRattachedInverseLayer) {
                        resolve(layer);
                        return;
                    }
                }

                this.$http
                    .get(`/api/rattachment/${rattachment.id}/${type}`, {
                        params: {
                            long: this.activeGeomObject.center.lng,
                            lat: this.activeGeomObject.center.lat,
                        },
                    })
                    .then(
                        (response) => {
                            // success callback
                            if (response && response.status === 200 && response.body) {
                                if (response.body.length) {
                                    for (let i = 0; i < response.body.length; i++) {
                                        if (response.body[i].geom) {
                                            layer.new_geom.push(response.body[i].geom);
                                            layer.ids.push(response.body[i].id);
                                        }
                                    }
                                }
                                resolve(layer);
                            } else {
                                console.error('response not valid', response);
                                reject();
                            }
                        },
                        (response) => {
                            // error callback
                            console.error(JSON.stringify(response));
                            reject();
                        },
                    );
            });
        },
        /**
         * Retourne la couche des objets en cours de sélection
         */
        getActiveGeomsLayer() {
            const layer = {
                type: 'selectedobjects',
                color: '#FFFF00',
                ids: [],
                new_geom: [],
            };
            if (this.activeObject && this.activeObject.geoms) {
                for (let i = 0; i < this.activeObject.geoms.length; i++) {
                    const geom = this.activeObject.geoms[i];
                    layer.new_geom.push(geom);
                }
            }

            return layer;
        },
        /**
         * Intersection avec le filaire sur un point donné
         */
        getFilaireOnPoint(rattachment, lat, long, nonRattached) {
            return new Promise((resolve, reject) => {
                const layer = {
                    type: 'filaireonpoint',
                    color: '#0026ff',
                    ids: [],
                    new_geom: [],
                    non_rattached_ids: [],
                };
                const route =
                    rattachment.isinverse === true
                        ? 'inversemetiergeom'
                        : nonRattached === true
                        ? 'oldnonratgeom'
                        : 'geom';

                this.$http
                    .get(`/api/rattachment/${rattachment.id}/${route}`, {
                        params: {
                            long: long,
                            lat: lat,
                        },
                    })
                    .then(
                        (response) => {
                            // success callback
                            if (response && response.status === 200 && response.body) {
                                if (response.body.length) {
                                    for (let i = 0; i < response.body.length; i++) {
                                        if (response.body[i].geom) {
                                            layer.new_geom.push(response.body[i].geom);
                                            layer.ids.push(response.body[i].id);
                                        }
                                        if (response.body[i].type === 'oldNonRattached') {
                                            layer.non_rattached_ids.push(response.body[i].id);
                                        }
                                    }
                                } else if (response.body.id) {
                                    if (response.body.geom) {
                                        layer.new_geom.push(response.body.geom);
                                        layer.ids.push(response.body.id);
                                    }
                                    if (response.body.type === 'oldNonRattached') {
                                        layer.non_rattached_ids.push(response.body.id);
                                    }
                                }
                                resolve(layer);
                            } else {
                                console.error('response not valid', response);
                                reject();
                            }
                        },
                        (response) => {
                            // error callback
                            console.error(JSON.stringify(response));
                            reject();
                        },
                    );
            });
        },
        /**
         * Sélection d'un rattachement
         */
        displayObject: function(event, multiple) {
            if (event && event.rattachment && event.rattachment.id) {
                if (
                    // active la multi-sélection seulement si on est en rattachement inverse (inverse = true)
                    this.inverse === true &&
                    multiple === true &&
                    this.activeObject &&
                    this.activeObject.objects &&
                    this.activeObject.rattachment &&
                    this.activeObject.rattachment.id &&
                    event.rattachment.id === this.activeObject.rattachment.id
                ) {
                    if (!this.isObjectSelected(event.object)) {
                        this.activeObject.objects.push(event.object);
                    } else {
                        return;
                    }
                } else {
                    this.activeObject = {
                        objects: [event.object],
                        rattachment: event.rattachment,
                        geoms: [],
                    };
                }

                this.openInfo = true;

                this.loadRattachmentObjectGeom(
                    this.activeObject.rattachment,
                    this.activeObject.objects[this.activeObject.objects.length - 1],
                ).then((geom) => {
                    this.activeObject.geoms.push(geom);
                    setTimeout(() => {
                        this.refreshLayers();
                    });
                });
            }
        },
        /**
         * Fermeture d'un rattachement
         */
        closeObjectInfo: function() {
            this.activeObject = null;
            this.activeGeomObject = null;
            this.openInfo = false;
            this.objectLayers.length = 0;
        },
        /**
         * Appelé lors de la mise à jour de l'étendue de la carte
         */
        refreshLayers: function() {
            // Charge les couches
            this.objectLayers.length = 0;
            this.objectLayers.push(this.getActiveGeomsLayer());

            if (this.activeObject && this.activeGeomObject) {
                if (this.inverse === true) {
                    this.getRattachementLayer(
                        'inversemetierratgeoms',
                        this.activeObject.rattachment,
                    ).then((geoms1) => {
                        this.getRattachementLayer(
                            'inversemetiernonratgeoms',
                            this.activeObject.rattachment,
                        ).then((geoms2) => {
                            this.objectLayers.length = 0;
                            this.objectLayers.push(geoms1);
                            if (this.showNonRattachedInverseLayer) {
                                this.objectLayers.push(geoms2);
                            }
                            this.objectLayers.push(this.getActiveGeomsLayer());
                        });
                    });
                } else {
                    this.getRattachementLayer('geoms', this.activeObject.rattachment).then(
                        (geoms1) => {
                            if (this.activeObject && this.activeObject.rattachment) {
                                this.getRattachementLayer(
                                    'oldratgeoms',
                                    this.activeObject.rattachment,
                                ).then((geoms2) => {
                                    this.getRattachementLayer(
                                        'oldnonratgeoms',
                                        this.activeObject.rattachment,
                                    ).then((geoms3) => {
                                        this.objectLayers.length = 0;
                                        this.objectLayers.push(geoms1);
                                        if (this.showOldRattachedLayer) {
                                            this.objectLayers.push(geoms2);
                                        }
                                        if (this.showOldNonRattachedLayer) {
                                            this.objectLayers.push(geoms3);
                                        }
                                        this.objectLayers.push(this.getActiveGeomsLayer());
                                    });
                                });
                            }
                        },
                    );
                }
            }
        },
        /**
         * Rattachement d'une géométrie sur les objets en cours de sélection
         */
        attachGeoms: function(geomId) {
            return new Promise((resolve) => {
                let counter = 0;
                if (this.activeObject && this.activeObject.objects) {
                    for (let i = 0; i < this.activeObject.objects.length; i++) {
                        const object = this.activeObject.objects[i];

                        this.attachGeom(geomId, object)
                            .then(() => {
                                counter++;
                                if (counter === this.activeObject.objects.length) {
                                    this.postAttachGeoms();
                                    resolve();
                                }
                            })
                            .catch(() => {
                                counter++;
                                if (counter === this.activeObject.objects.length) {
                                    this.postAttachGeoms();
                                    resolve();
                                }
                            });
                    }
                }
            });
        },
        /**
         * Rattachement d'une géométrie sur l'objet en paramètre
         */
        attachGeom: function(geomId, object) {
            return new Promise((resolve, reject) => {
                if (object) {
                    const object_id =
                        object[`${this.activeObject.rattachment.fid}_old_rattachment`];
                    if (object_id) {
                        this.$http
                            .put(
                                `/api/rattachment/${
                                    this.activeObject.rattachment.id
                                }/${object_id}/attach`,
                                {
                                    geom_id: geomId,
                                },
                            )
                            .then(
                                (response) => {
                                    if (response && response.status === 200 && response.body) {
                                        resolve();
                                    } else {
                                        reject();
                                    }
                                },
                                (response) => {
                                    // error callback
                                    console.error(JSON.stringify(response));
                                    reject();
                                },
                            );
                    }
                }
            });
        },
        /**
         * Actions appelées après les rattachements des géométries
         */
        postAttachGeoms: function() {
            this.popup = null;
            // Passe la couleur de l'objet actif à null de manière à donner l'illusion que l'objet rouge (non rattaché) est devenu gris (rattaché)
            this.activeGeomObject.color = null;
            // permet de fermer la sélection en cours
            setTimeout(() => {
                this.closeObjectInfo();
            }, 500);
            this.refreshLayers();
            const openedRattachments = this.getOpenedRattachments(this.rattachments);
            this.getRattachmentsMenu(openedRattachments);
        },
        /**
         * Charge les attributs d'un objet
         */
        getObjectById: function(object_id) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(`/api/rattachment/${this.activeObject.rattachment.id}/${object_id}/object`)
                    .then(
                        (response) => {
                            if (response && response.status === 200 && response.body) {
                                resolve(response.body);
                            } else {
                                reject();
                            }
                        },
                        (response) => {
                            // error callback
                            console.error(JSON.stringify(response));
                            reject();
                        },
                    );
            });
        },
        /**
         * Charge les attributs d'une géométrie dans le formulaire rattachement inverse
         */
        loadGeomAttrbutes: function(object_id) {
            return new Promise((resolve, reject) => {
                this.$http
                    .get(
                        `/api/rattachment/${
                            this.activeObject.rattachment.id
                        }/${object_id}/attributes`,
                    )
                    .then(
                        (response) => {
                            if (response && response.status === 200 && response.body) {
                                // this.changeActiveObjectAttributes(response.body);
                                resolve(response.body);
                            } else {
                                reject();
                            }
                        },
                        (response) => {
                            // error callback
                            console.error(JSON.stringify(response));
                            reject();
                        },
                    );
            });
        },
        /**
         * Met à jour les attributs de l'objet en cours d'édition
         */
        changeActiveObjectAttributes: function(attributes) {
            if (this.activeObject && this.activeObject.objects) {
                const objects = [];
                for (let i = 0; i < this.activeObject.objects.length; i++) {
                    const object = { ...this.activeObject.objects[i] };
                    for (const key in attributes) {
                        if (attributes.hasOwnProperty(key)) {
                            if (key !== this.activeObject.rattachment.fid) {
                                object[key] = attributes[key];
                            }
                        }
                    }
                    objects.push(object);
                }
                this.activeObject.objects = objects; // Obligé de faire une réassignation des pointeurs pour que le vue de Rattachementinfo fasse un digest
            }
        },
        /**
         * Événement appelé au clic sur la carte
         */
        handleMapClick: function(e) {
            if (this.activeObject && this.activeGeomObject) {
                if (e.latlng) {
                    this.popup = null;
                    this.getFilaireOnPoint(
                        this.activeObject.rattachment,
                        e.latlng.lat,
                        e.latlng.lng,
                    ).then((geoms) => {
                        if (geoms && geoms.new_geom && geoms.new_geom[0]) {
                            if (this.inverse === true) {
                                if (geoms && geoms.ids && geoms.ids[0]) {
                                    this.loadGeomAttrbutes(geoms.ids[0])
                                        .then((attributes) => {
                                            this.displayRatInversePopup(geoms, attributes);
                                        })
                                        .catch(() => {
                                            this.addRatInverseMultiSelectionByGeom(geoms);
                                        });
                                }
                            } else {
                                // Objet non rattaché (rouge)
                                if (geoms.non_rattached_ids.length > 0) {
                                    this.getObjectById(geoms.ids[0])
                                        .then((obj) => {
                                            if (geoms.new_geom && geoms.new_geom[0]) {
                                                obj.new_geom = geoms.new_geom[0];
                                            }
                                            if (obj) {
                                                this.addRatMultiSelectionObject(obj);
                                            }
                                        })
                                        .catch(() => {});
                                } else {
                                    if (this.showRattachementsLayer) {
                                        // Affiche la popup de rattachement
                                        this.displayRatPopup(geoms);
                                    }
                                }
                            }
                        }
                    });
                }
            }
        },
        /**
         * Récupère les id des rattachements ouverts
         */
        getOpenedRattachments: function(rattachments) {
            const openedRattachments = [];
            for (let i = 0; i < rattachments.length; i++) {
                const rat = rattachments[i];
                if (rat.id && rat.opened === true) {
                    openedRattachments.push(rat.id);
                }
            }
            return openedRattachments;
        },
        /**
         * Met à jour les rattachements précédemment ouverts
         */
        setOpenedRattachments: function(openedRattachments, rattachments) {
            for (let i = 0; i < rattachments.length; i++) {
                const rat = rattachments[i];
                if (rat.id && openedRattachments.indexOf(rat.id) !== -1) {
                    rat.opened = true;
                }
            }
        },
        /**
         * Fonction appelée à la validation du formulaire d'édition des attributs d'un objet rattachement inverse
         */
        validInverseForm: function() {
            if (this.activeObject.objects && this.activeObject.rattachment) {
                this.updateInvRatObjectsAttributes(
                    this.activeObject.objects,
                    this.activeObject.rattachment,
                );
            }
        },
        /**
         * Mise à jour des données attributaires des objets de rattachement inverse
         */
        updateInvRatObjectsAttributes: function(objects, rattachment) {
            return new Promise((resolve) => {
                let counter = 0;
                for (let i = 0; i < objects.length; i++) {
                    const object = objects[i];
                    this.updateInvRatObjectAttributes(object, rattachment)
                        .then(() => {
                            counter++;
                            if (counter === objects.length) {
                                this.postUpdateInvRatObjectsAttributes();
                                resolve();
                            }
                        })
                        .catch(() => {
                            counter++;
                            if (counter === objects.length) {
                                this.postUpdateInvRatObjectsAttributes();
                                resolve();
                            }
                        });
                }
            });
        },
        /**
         * Mise à jour des données attributaires d'un objet de rattachement inverse
         */
        updateInvRatObjectAttributes: function(object, rattachment) {
            return new Promise((resolve, reject) => {
                // remplace les "" par null
                for (const key in object) {
                    if (object.hasOwnProperty(key)) {
                        if (object[key] === '') {
                            object[key] = null;
                        }
                    }
                }

                if (rattachment && rattachment.fid && object && object[rattachment.fid]) {
                    if (object.new_geom) {
                        delete object.new_geom;
                    }
                    const object_id = object[rattachment.fid];
                    this.$http
                        .put(`/api/rattachment/${rattachment.id}/${object_id}/insert_attr`, object)
                        .then(
                            (response) => {
                                if (response && response.status === 200 && response.body) {
                                    resolve();
                                } else {
                                    reject();
                                }
                            },
                            (response) => {
                                // error callback
                                console.error(JSON.stringify(response));
                                reject();
                            },
                        );
                } else {
                    console.error('rattahcment or object not valid', object, rattachment);
                    reject();
                }
            });
        },
        /**
         * Fonction appelée après mise à jour des données attributaires de rattachement inverse
         */
        postUpdateInvRatObjectsAttributes: function() {
            this.popup = null;
            // Passe la couleur de l'objet actif à null de manière à donner l'illusion que l'objet rouge (non rattaché) est devenu gris (rattaché)
            this.activeGeomObject.color = null;
            // ferme la sélection en cours
            this.closeObjectInfo();
            this.refreshLayers();
            const openedRattachments = this.getOpenedRattachments(this.rattachments);
            this.getRattachmentsMenu(openedRattachments);
        },
        /**
         * Affiche la popup permettant de sélectionner le filaire à rattacher
         */
        displayRatPopup: function(geoms) {
            // Contenu HTML
            const htmlContent = document.createElement('div');
            htmlContent.style.marginRight = '10px';
            const htmlText = document.createElement('label');
            htmlText.innerHTML = 'Utiliser ce filaire';
            htmlText.style.fontSize = '16px';
            const htmlButton = document.createElement('button');
            htmlButton.innerHTML = '✓';
            htmlButton.classList = 'osm-button default';
            htmlButton.style.padding = '0px 6px';
            htmlButton.style.borderRadius = '3px';
            htmlButton.onclick = () => {
                if (geoms && geoms.ids && geoms.ids[0]) {
                    this.attachGeoms(geoms.ids[0]);
                }
            };
            htmlContent.appendChild(htmlText);
            htmlContent.appendChild(htmlButton);

            this.popup = {
                geom: geoms,
                content: htmlContent,
            };
        },
        /**
         * Affiche la popup permettant de sélectionner le filaire du rattachement inverse
         */
        displayRatInversePopup: function(geoms, attributes) {
            // Contenu HTML
            const htmlContent = document.createElement('div');
            htmlContent.style.marginRight = '10px';
            const htmlButton = document.createElement('button');
            htmlButton.innerHTML = '✓';
            htmlButton.classList = 'osm-button default';
            htmlButton.style.padding = '0px 6px';
            htmlButton.style.borderRadius = '3px';
            htmlButton.style.float = 'right';
            htmlButton.onclick = () => {
                this.changeActiveObjectAttributes(attributes);
                this.popup = null;
            };
            // htmlContent.appendChild(htmlText);
            htmlContent.appendChild(htmlButton);

            // Affichage des attributs
            for (const key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    const val = attributes[key];
                    const line = document.createElement('div');
                    const attrHtml = document.createElement('label');
                    attrHtml.innerHTML = `${key} : ${val}`;
                    attrHtml.style.fontSize = '14px';
                    line.appendChild(attrHtml);
                    htmlContent.appendChild(line);
                }
            }

            this.popup = {
                geom: geoms,
                content: htmlContent,
            };
        },
        /**
         * Ajoute une sélection au rattachement inverse par sa géométrie
         */
        addRatInverseMultiSelectionByGeom: function(geoms) {
            if (geoms && geoms.ids && geoms.ids[0] && geoms.new_geom && geoms.new_geom[0]) {
                if (
                    this.activeObject &&
                    this.activeObject.objects &&
                    this.activeObject.rattachment &&
                    this.activeObject.rattachment.fid
                ) {
                    const object = {
                        new_geom: geoms.new_geom[0],
                    };
                    object[this.activeObject.rattachment.fid] = geoms.ids[0];

                    const event = {
                        rattachment: this.activeObject.rattachment,
                        object: object,
                    };

                    this.displayObject(event, true);
                }
            }
        },
        /**
         * Ajoute une sélection au rattachement simple
         */
        addRatMultiSelectionObject: function(object) {
            if (object) {
                if (
                    this.activeObject &&
                    this.activeObject.objects &&
                    this.activeObject.rattachment &&
                    this.activeObject.rattachment.fid
                ) {
                    const event = {
                        rattachment: this.activeObject.rattachment,
                        object: object,
                    };
                    this.displayObject(event, true);
                }
            }
        },
        /**
         * Retourne true si un objet est sélectionné
         */
        isObjectSelected: function(obj) {
            if (
                this.activeObject &&
                this.activeObject.objects &&
                this.activeObject.rattachment &&
                this.activeObject.rattachment.fid
            ) {
                for (let i = 0; i < this.activeObject.objects.length; i++) {
                    const object = this.activeObject.objects[i];
                    if (
                        obj[this.activeObject.rattachment.fid] &&
                        obj[this.activeObject.rattachment.fid] ===
                            object[this.activeObject.rattachment.fid]
                    ) {
                        return true;
                    }
                    if (
                        obj[`${this.activeObject.rattachment.fid}_old_rattachment`] &&
                        obj[`${this.activeObject.rattachment.fid}_old_rattachment`] ===
                            object[`${this.activeObject.rattachment.fid}_old_rattachment`]
                    ) {
                        return true;
                    }
                }
            }
            return false;
        },
        /**
         * Désélectionne un objet
         */
        unselectObject: function(obj) {
            if (
                this.activeObject &&
                this.activeObject.objects &&
                this.activeObject.objects.indexOf(obj) !== -1
            ) {
                const idKey = obj[`${this.activeObject.rattachment.fid}_old_rattachment`]
                    ? `${this.activeObject.rattachment.fid}_old_rattachment`
                    : this.activeObject.rattachment.fid;

                if (idKey && obj[idKey]) {
                    for (var i = this.activeObject.objects.length - 1; i >= 0; i--) {
                        const object = this.activeObject.objects[i];
                        if (obj[idKey] === object[idKey]) {
                            this.activeObject.objects.splice(i, 1);
                        }
                    }
                    for (var j = this.activeObject.geoms.length - 1; j >= 0; j--) {
                        const geom = this.activeObject.geoms[j];
                        if (obj[idKey] === geom.id) {
                            this.activeObject.geoms.splice(j, 1);
                        }
                    }
                }

                if (this.activeObject.objects.length > 0) {
                    this.activeGeomObject.color = null;
                    this.refreshLayers();
                } else {
                    this.closeObjectInfo();
                }
            }
        },
    },

    components: {
        LoadingDots,
        ConfigLink,
        OsmMap,
        RattachmentObjects,
        RattachmentObjectInfo,
        Checkbox,
        MenuLink,
    },

    computed: {},
};
</script>

<style lang="scss">
$menu-width: 240px;

#rattachment-view {
    display: flex;
    flex-direction: row;

    .rattachment-body {
        margin: 25px 30px;
        padding: 20px 0;
        border: 1px solid #9ca5b0;
        border-radius: 5px;
        border-top: 5px solid #6c3e91;
        background-color: #ffffff;

        .rattachment-section {
            width: 75%;
            h3.section--title {
                // margin-left: 35px;
                margin: 5px 35px 20px;
                padding-bottom: 5px;
                font-size: 2em;
                font-weight: 600;
                text-transform: uppercase;
                border-bottom: 3px solid black;
            }
            h4.subsection--title {
                margin: 5px 35px 20px;
                padding-top: 5px;
                padding-bottom: 5px;
                font-size: 1.5em;
                font-weight: 400;
                border-bottom: 1.5px solid grey;
            }
        }

        .mt-5 {
            margin-top: 5em;
        }

        .sm-field {
            width: 65%;
        }
    }

    .rattachment-menu {
        width: $menu-width;
        background-color: #ffffff;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;

        .logo {
            width: $menu-width;
            height: 50px;
            background-color: #6c3e91;
            flex-shrink: 0;
            flex-grow: 0;
            flex-basis: 50px;

            display: flex;
            flex-direction: column;
            justify-content: center;

            > img {
                margin-left: 20px;
                display: block;
                max-width: 115px;
                height: auto;
            }
        }

        .config {
            flex-shrink: 0;
            flex-grow: 0;
            display: flex;
            flex-direction: column;
        }

        .objects {
            overflow: auto;
        }

        .layers {
            // margin: 5px;
            padding-top: 50px;
            letter-spacing: 0.85px;

            .layers-title {
                padding-left: 50px;
                color: #6c3e91;
                border-left: 3px solid #6c3e91;
                font-size: 13px;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.85px;
            }

            .layer {
                font-size: 14px;
                margin: 10px 5px;
            }
        }

        .geom .checkmark {
            background-color: #6c757d;
        }
        .oldratgeom .checkmark {
            background-color: #28a745;
        }
        .oldnonratgeom .checkmark {
            background-color: #dc3545;
        }
        .inversemetierratgeoms .checkmark {
            background-color: #28a745;
        }
        .inversemetiernonratgeoms .checkmark {
            background-color: #dc3545;
        }
    }
}

.title {
    color: #151b25;
    margin: 20px 30px;
    font-size: 22px;
    font-weight: 600;
    line-height: 30px;
}

.rattachment-title {
    padding: 14px 48px;
    color: #2a2a2a;
    font-size: 19px;
    font-weight: 600;
    line-height: 26px;
    text-align: center;
    width: 100%;
}

.rattachment-button {
    margin-top: 25px;
    text-align: center;
}

.osm-button {
    cursor: pointer;
}

.osm-button.warning,
.osm-button.warning:focus {
    background-color: orange;
}

.osm-button.danger,
.osm-button.danger:focus {
    background-color: red;
}

.dropdown {
    cursor: pointer;
}
</style>
